module.exports = __webpack_public_path__ + "static/media/subscription-section-1.7feb2935.png";